export default __webpack_public_path__ + "static/media/jsBW.03b074e1.webp";